import events from '@wizer/core/events'
import NonConcurrentUploadService from '@/utils/NonConcurrentUploadService'
import ApiService from './ApiService'
import store from '../store/store'

const resourceUrl = `${ApiService.prefix}rest/data/walkthrough/`

export default {
  getThumbnailUrl(file) {
    const base = `${process.env.VUE_APP_E360_BASE_URL}${process.env.VUE_APP_E360_REST_URL}${ApiService.prefix}`
    return `${base}rest/data/systemModule/attachments/download?dbFileUid=${file.data.id}&thumbnail=true`
  },
  download(file) {
    return ApiService.get(
      `${ApiService.prefix}rest/data/systemModule/attachments/download?dbFileUid=${file.id}`,
      {
        responseType: 'blob',
      },
    ).then((response) => new File([response.data], file.fileName))
  },
  async upload(file) {
    events.publish('file-upload-started')
    const formData = new FormData()
    formData.append('file', file)
    formData.append('fileName', file.name)
    return NonConcurrentUploadService.post(`${resourceUrl}/image`, formData).then(
      async (response) => {
        await store.dispatch('WalkthroughAttachments/addAddedImage', response.data.id, {
          root: true,
        })
        events.publish('file-upload-finished')
        file.id = response.data.id
        file.fileName = response.data.fileName
        response.data.success = true
        response.data.label = response.data.fileName
        return response.data
      },
    )
  },
  async remove(file) {
    return new Promise((resolve) => {
      events.confirm(async () => {
        await store.dispatch('WalkthroughAttachments/addRemovedImage', file.id, { root: true })
        const response = {}
        response.success = true
        resolve(response)
      }, 'Deleting an image will remove it from all existing, completed Walkthrough records. \n\n Do you want to continue?')
    })
  },
}
